module.exports = __webpack_public_path__ + "static/about_check_pc-98688345513024bbe1ac08dc6661fc56.jpg";